import { observer } from "mobx-react-lite";
import styles from "./superAdminOrganisationsPage.module.scss";
import SelectOrganizationTable from "./selectOrganizationTable/selectOrganizationTable";
import MobileSuperAdminOrganisationsPage from "./mobile/mobileSuperAdminOrganisationsPage";
import appStore from "@source/store/appStore";

const SuperAdminOrganisationsPage = observer(() => {
  return(
   <div className={styles.selectOrganization}>
      <div className={styles.table}>
        {appStore.getIsMobile() ? <MobileSuperAdminOrganisationsPage /> : <SelectOrganizationTable />}
      </div>
    </div>
  )
});

export default SuperAdminOrganisationsPage;